import Icon from '../components/Icon.vue'

Icon.register({
  images: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M480 416v16c0 26.5-21.5 48-48 48h-384c-26.5 0-48-21.5-48-48v-256c0-26.5 21.5-48 48-48h16v208c0 44.1 35.9 80 80 80h336zM576 336c0 26.5-21.5 48-48 48h-384c-26.5 0-48-21.5-48-48v-256c0-26.5 21.5-48 48-48h384c26.5 0 48 21.5 48 48v256zM256 128c0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48 48-21.5 48-48zM160 272v48h352v-112l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0l-135.5 135.5-39.5-39.5c-4.7-4.7-12.3-4.7-17 0z'
      }
    ]
  }
})
